import { createScenarioStub } from "../scenarioFlow/ScenarioFlowStub";
import { ROUTES } from "../../utils/constants";

export default createScenarioStub({
	scenarioNum: 5,
	kind: "quiz",
	label: "Pregunta 6 (plantilla)",
	nextRoute: ROUTES.SCENARIO5_FIN,
});
